module.exports = __webpack_public_path__ + "img/01.bd998a00.jpg";